import '@/assets/css/global.css'
import '@/assets/css/ui.css'

import Vue from 'vue'
import App from './index.vue'

import Vant from 'vant';
import 'vant/lib/index.css';

import qs from "qs"
Vue.prototype.$qs = qs

Vue.use(Vant);

let mainApp = null;

import '@/directives/index'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
        opacity: 0.6,
        background : '#ba905b',
        size: '6px',
        gutterOfSide : '0px',
    },
    bar: {
        background: '#624520',
        keepShow : true,
        size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import {$get,$post} from "@/assets/js/axios.http.js"
Vue.prototype.$get = $get
Vue.prototype.$post = $post

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// Share_Modal
import Share_Modal from '@/components/ShareModal';
Vue.prototype.$share_modal = Share_Modal;

// Share_Modal
import Share_Warn from '@/components/ShareWarn';
Vue.prototype.$share_warn = Share_Warn;

// Share_Modal
import WebShare_Modal from '@/components/WebShare';
Vue.prototype.$web_share = WebShare_Modal;

// Warn_Modal
import Warn_Modal from '@/components/WarnModal';
Vue.prototype.$warn_modal = Warn_Modal;

// Msg_Modal
import Msg_Modal from '@/components/MsgModal';
Vue.prototype.$msg_modal = Msg_Modal;

// Reward_Modal
import Reward_Modal from '@/components/RewardModal';
Vue.prototype.$reward_modal = Reward_Modal;

// Team_Modal
import Team_Modal from '@/components/TeamInfo';
Vue.prototype.$team_info_modal = Team_Modal;

// Invite_Modal
import Invite_Modal from '@/components/InviteApply';
Vue.prototype.$invite_modal = Invite_Modal;

// Comfirm_Modal
import Comfirm_Modal from '@/components/Comfirm';
Vue.prototype.$comfirm_modal = Comfirm_Modal;

// Comfirm_Buy
import Comfirm_Buy from '@/components/ComfirmBuy';
Vue.prototype.$comfirm_buy = Comfirm_Buy;

// Msg_Modal
import Msgs_Modal from '@/components/MsgModalSmall';
Vue.prototype.$msgs_modal = Msgs_Modal;


// Luck_Modal
import Luck_Modal from '@/components/LuckModal';
Vue.prototype.$luck_modal = Luck_Modal;

// result_Modal
import Result_Modal from '@/components/ResultModal';
Vue.prototype.$result_modal = Result_Modal;

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);


Vue.prototype.$update_evt = function (data) {
  mainApp.user_init();
  mainApp.$refs.app.$refs.team.init();
};

Vue.prototype.$update_team = function (data) {
  mainApp.$refs.app.$refs.team.init();
};

Vue.prototype.$update_user = function (data) {
  mainApp.user_init();
};

Vue.prototype.$clear_code = function(id,type){
  mainApp.$refs.app.code = '';
};

mainApp = new Vue({
    el: '#app',
    components: {
      App
    },
    template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门
        share_id : 'ME21',
        key : '',
        share : '',
        token : '',        
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('jwt') || localStorage.getItem("token");
      _this.token = token;
      
      let code = GLOBAL.getQueryVariable('key') || localStorage.getItem("code");

      if(GLOBAL.getQueryVariable('key')){
        //this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
        localStorage.setItem('code', code);
        //window.history.pushState({}, 0, GLOBAL.domain);
      }

      if(GLOBAL.getQueryVariable('share')){
        this.$store.commit("$_setShare", GLOBAL.getQueryVariable('share'));
        //window.history.pushState({}, 0, GLOBAL.domain);
      } 
      
      let share = store.state.share;      
      
      this.key = code;
      this. share = share;

      if (token) {
        localStorage.setItem('token', token);
        _this.$store.commit("$_setToken", token);
      }

      window.history.pushState({}, 0, GLOBAL.domain);
    },
    mounted (){
        this.get_user_info();
        wx.wxInit({
          title: GLOBAL.wx_share_text.title, // 分享标题
          desc: GLOBAL.wx_share_text.desc, // 分享描述
          link: GLOBAL.domain, // 分享链接
          imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });         
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        this.ua.uid = this.ua.uid || 0;

        Free_login.free_login_lazy(
          this.$store.state.userinfo.accountid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
              localStorage.setItem('token', _this.token);
              _this.$store.commit("$_setToken", _this.token);              
            }
            _this.user_init();

          }
        );       
      },      
      user_init (){
        let _this = this;
        this.$post(ajax_url_map.userinfo,{
            success : (data) => {
              _this.$store.commit("$_setUserinfo", data.userInfo);
              _this.$store.commit("$_setAccount", data.data);
              _this.$store.commit("$_setLogin", 1);

              //console.log(mainApp.$refs.app.$refs.team);

              _this.ready = true;
              if(localStorage.getItem("code"))return _this.$invite_modal({code : _this.key});
              if(_this.share){
                _this.share_accepet ();
              }              
             
            },
            error : (data) => {
              _this.ready = true;
                

                if(data.userInfo){
                  _this.$store.commit("$_setUserinfo", data.userInfo);
                  _this.$store.commit("$_setLogin", 1);
                }
                if(data.code == 402){
                  _this.$bind_modal();
                }

                if(localStorage.getItem("code"))return _this.$invite_modal({code : _this.key});
                if(_this.share)return this.$share_warn();
            },
        })
      },
      share_accepet (){
        let _this = this;

        _this.$axios.post(ajax_url_map.share_gift,this.$qs.stringify({
          share : _this.share,
        }))
        .then(
          res => {
            _this.$toast('助力成功，恭喜获得燃梦火炬*1');
            _this.share = '';
          },
          rej => {
            _this.$toast(rej.message)
            _this.share = '';
          }
        )         
      },           
    },
  })




// WEBPACK FOOTER //
// ./src/page/index/index.js